<template>
  <v-dialog-old ref="dialog" id="duplicateDialog" :onCloseEsc="() => {}">
    <fieldset width="600">
      <legend>Врач найден в базе</legend>
      <div v-for="(d, i) in doctors" class="doctorBtn"
           @click.prevent="selectDoctor(i)"
           :class="{selected: selectedDoctorIndex === i, hover: !blockedDoctor(i), pointer: !blockedDoctor(i), grayText:blockedDoctor(i) }"
      >
        <img :src="d.img ? public_storage_url + '/images/doctors/150x225/' + d.img : (d.sex === 'FEMALE' ? '/_assets/pic_she.svg' : '/_assets/pic_he.svg')"
            style="width:75px; height:112px; cursor:pointer;"
        />
        <template v-if="d.deleted_at !== null">
          <div><b>{{ d.nameFamily }} {{ d.nameFirst }} {{ d.nameFathers }} <span
              class="text-danger"> (ВРАЧ УДАЛЕН)</span></b></div>
          <div> Причина удаления: {{ deletionStatus(i) }}</div>
          <div v-if="d.deletionReason !== null && d.deletionReason.comment !== ''">
            Комментарий: {{ d.deletionReason.comment }}
          </div>
        </template>
        <template v-else>
          <div><b>{{ d.nameFamily }} {{ d.nameFirst }} {{ d.nameFathers }} </b></div>
        </template>

        <div><i>{{ d.specialitiesAsText }}</i></div>

        <div class="comma">
          <span v-if="d.experience !==''">Стаж:
            {{ d.experience | pluralize('', '$ год', '$ года', '$ лет')}}
          </span>

          <span v-if="d.degree !== ''">{{
              ({
                'DMN': 'Доктор наук',
                'KMN': 'Кандидат наук',
                'NONE': 'Нет ученой степени'
              })[d.degree]
            }}</span>
          <span v-if="d.category !== ''">{{
              ({
                'TOP': 'Высшая категория',
                'FIRST': 'Первая категория',
                'SECOND': 'Вторая категория',
                'NONE': 'Нет категории',
              })[d.category]
            }}</span>
          <span v-if="d.rank !== ''">{{
              ({
                'PROFESSOR': "Профессор",
                'DOCENT': "Доцент",
                'NONE': "Нет звания",
              })[d.rank]
            }}</span>
        </div>
        <div v-if="d.bestCityCharId != null">
          <a :href="$root.frontendUrl + '/' + d.bestCityCharId + '/doctor/' +d.url" @click.stop="" target="_blank">{{$root.frontendUrl}}/{{ d.bestCityCharId }}/doctor/{{ d.url }}</a>
        </div>
      </div>
      <div class="cancelBtn hover pointer" @click="selectedDoctorIndex = 'NEW'"
           :class="{selected: selectedDoctorIndex === 'NEW'}">
        <template v-if="doctors.length > 1">
          Это другие врачи, создать нового врача
        </template>
        <template v-else>
          Это другой врач, создать нового врача
        </template>
      </div>
    </fieldset>
    <footer>
      <v-loading-component @click="confirm">
        <template slot-scope="{ loadingClass }">
          <button :disabled="selectedDoctorIndex === null" :class="['green', loadingClass]">Ок</button>
        </template>
      </v-loading-component>
    </footer>
  </v-dialog-old>
</template>

<script>
import {STORAGE_PUBLIC} from "@global/const";

export default {
  props: {},
  data() {
    return {
      public_storage_url: STORAGE_PUBLIC,
      selectedDoctorIndex: null,
      doctors: []
    }
  },
  computed: {},
  methods: {
    selectDoctor(index) {
      if (this.blockedDoctor(index) === false) {
        this.selectedDoctorIndex = index;
      }
    },
    blockedDoctor(index) {
      return !!(this.doctors[index].deletionReason !== undefined &&
          this.doctors[index].deletionReason !== null &&
          this.doctors[index].deletionReason.blocker);

    },
    deletionStatus(index) {
      if (this.doctors[index].deletionReason !== undefined && this.doctors[index].deletionReason !== null) {
        return this.doctors[index].deletionReason.reason;
      }
      return 'не указана';
    },
    show(doctors) {
      this.selectedDoctorIndex = null;
      this.doctors = doctors;
      this.$refs.dialog.show();
    },

    confirm() {
      if (this.selectedDoctorIndex !== 'NEW') {
        this.$emit('onSelectDoctor', this.doctors[this.selectedDoctorIndex]['id']);
      }
      this.$refs.dialog.hide();
    },

    cancel: function () {
      this.$emit('onCancel');
      this.$refs.dialog.hide();
    }
  },
}
</script>

<style lang="scss">
#duplicateDialog {
  width: 705px !important;
}
#duplicateDialog .doctorBtn {
  position: relative;
  padding: 5px 5px 5px 90px;
  min-height: 125px;
  border: 2px solid #9c9c9c;
  border-radius: 5px;
  margin: 5px;
}
#duplicateDialog .doctorBtn img {
  position: absolute;
  top: 5px;
  left: 5px;
}
#duplicateDialog .grayText {
  color: gray;
}
#duplicateDialog .cancelBtn {
  position: relative;
  padding: 10px;
  min-height: 30px;
  border: 2px solid #9c9c9c;
  border-radius: 5px;
  margin: 5px;
  text-align: center;
}
#duplicateDialog .selected {
  background-color: rgba(48, 142, 255, 0.31) !important;
}
</style>
